import { Elements } from '@/components';
import featuresBackground from '@images/hero-bg.webp';
import { Link } from 'react-router-dom';

export const ReadToBuild = () => {
    return (
        <section
            className="overflow-hidden bg-cover bg-center bg-no-repeat px-5 pt-15 pb-15 md:px-10 lg:px-[79px]"
            style={{
                backgroundImage: `url(${featuresBackground})`,
            }}
        >
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-4">
                <Elements.Title
                    title="Ready to Build Your ICHRA Business?"
                    type="h2"
                    className="text-center text-gray-50"
                />
                <Elements.Description
                    description="Join the platform that puts your success first and your brand at the center of everything we do."
                    type="medium"
                    className="text-center max-w-[450px] w-full text-gray-50"
                />
                <div className='flex items-center justify-center gap-4'>
                    <Link to="/demo">
                        <Elements.Button variant="white" size="xl">
                            <span className='text-base md:text-xl lg:text-xl'>Book a Demo</span>
                        </Elements.Button>
                    </Link>
                </div>
            </div>
        </section>
    );
};
